import React from 'react';
import './GalleryPage.css';

const HeroBlock = ({ label, title, text, image, chipOne = 'Live Tracking', chipTwo = '24/7 Control Room' }) => (
  <section className="enhanced-hero" style={{ backgroundImage: `url(${image})` }}>
    <div className="container enhanced-hero-grid">
      <div className="enhanced-copy reveal-left">
        <span className="section-label eyebrow-dark">{label}</span>
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{text}</p>
        <div className="hero-actions">
          <a href="/contact-us" className="btn btn-primary">Get Free Consultation</a>
          <a href="/packages" className="btn btn-outline">View Packages</a>
        </div>
        <div className="hero-metrics">
          <span><strong>6,500+</strong>Vehicles Served</span>
          <span><strong>24/7</strong>Monitoring</span>
          <span><strong>2019</strong>Since</span>
        </div>
      </div>
      <div className="hero-visual-wrap reveal">
        <div className="floating-orbit" />
        <div className="float-chip one"><b />{chipOne}</div>
        <div className="float-chip two"><b />{chipTwo}</div>
        <div className="hero-visual"><img src={image} alt={label} /></div>
      </div>
    </div>
  </section>
);

const tiles=[['/dts-assets/ai/corporate-hero.png','Corporate Fleet Dashboard'],['/dts-assets/ai/consumer-hero.png','Personal Vehicle Tracking'],['/dts-assets/ai/solutions-hero.png','Smart Monitoring Platform'],['/dts-assets/ai/gallery-hero.png','Installation & Operations'],['/dts-assets/ai/team-hero.png','Support Team'],['/dts-assets/ai/contact-hero.png','Karachi Head Office']];
const GalleryPage=()=>(<main className="enhanced-page gallery-enhanced"><HeroBlock label="Gallery" title="Dynamic Tracking <em>Visual Showcase</em>" text="Explore the DTS service experience through fleet dashboards, GPS monitoring visuals, installation concepts, operations support, and customer-focused tracking solutions." image="/dts-assets/ai/gallery-hero.png" chipOne="Operations" chipTwo="Tracking Visuals" />
<section className="enhanced-section alt"><div className="container"><div className="section-header reveal"><span className="section-label">Visual Gallery</span><h2>Fleet, Tracking, Operations, and <em>Support</em></h2><div className="divider"/><p>Premium web-ready visuals arranged for a professional corporate website gallery.</p></div><div className="gallery-grid">{tiles.map((t,i)=><div className={`gallery-tile reveal ${i===0?'big':''}`} key={t[1]}><img src={t[0]} alt={t[1]}/><span>{t[1]}</span></div>)}</div></div></section></main>);
export default GalleryPage;
